import * as React from 'react';
import type { SVGProps } from 'react';
const SvgContainer = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}>
    <path fill="#616061" d="M4 2H0v12h4V2Z" />
    <path fill="#616061" d="M16 2H6v12h10V2Z" />
  </svg>
);
export default SvgContainer;
